import React from "react"
import { Box, Flex, Heading, useMediaQuery } from "@chakra-ui/react"
import { mobileBreakpoint } from "../common/commonConstants"

const Error: React.FC = () => {
  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)

  return (
    <>
      <Flex align={"flex-start"} flexDir={"column"} p="4" pl={[4, 4, 0]} minH={["425px", "425px", "629px"]}>
        {isDesktop && (
          <Heading variant="Heading1SemiBold" maxW="860px" mt={["69", "42", "20"]} mb="0" pb="0">
            Oops!
            <Box mt="4px">This webpage is not</Box>
            <Box mt="0" mb="0">
              available.
            </Box>
          </Heading>
        )}
        {!isDesktop && (
          <Heading variant="Heading1SemiBold" maxW="860px" mt={["71", "42", "20"]} mb="0" pb="0">
            Oops!
            <Box mt="1" mb="0">
              This webpage is not available.
            </Box>
          </Heading>
        )}

        <Heading variant="Heading3PT" mt={["4", "14px", "20px"]} pt="0">
          Please try reloading the page.
        </Heading>
      </Flex>
    </>
  )
}

export default Error
